/**
 * Given a URL that may be to a protein, get its API ID.
 *
 * Note that we may want to move this to a more general-purpose place in the
 * future.
 */
import ModelTypeConstants from 'constants/ModelTypeConstants';
import Apiutil from 'util/APIUtil';

// eslint-disable-next-line @typescript-eslint/unbound-method
const {typeToApiPrefix} = Apiutil;

// Match the format for the editor endpoint, from benchling/profiles/folders.py:
// /f/<folder_api_id>-<folder_vanity>/
// <non_hyphen_underscore:api_prefix>-<non_hyphen_underscore:api_id>-<vanity>/edit
const PROTEIN_PREFIX = typeToApiPrefix(ModelTypeConstants.PROTEIN);
const PATH_REGEX = new RegExp(`/${PROTEIN_PREFIX}-([^-]*)-`);

const parseProteinIdFromUrl = (url: string): string | null => {
  // Note that we don't currently check that the URL matches our origin. It
  // makes testing more of a pain, and there may be URLs (e.g. ones with "www")
  // where we would get false negatives, and the benefit is really minor (and
  // unimportant for security).

  // Use the DOM to parse the URL a little: https://gist.github.com/jlong/2428561 .
  const el = document.createElement('a');
  el.href = url;
  const path = el.pathname;
  const matchResult = PATH_REGEX.exec(path);
  if (!matchResult) {
    return null;
  }
  return `${PROTEIN_PREFIX}_${matchResult[1]}`;
};

export default parseProteinIdFromUrl;
